var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"exception-view"}},[_c('b-container',{staticStyle:{"margin-top":"40px"}},[(_vm.user.role === 'admin')?_c('list-exception'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }